import { FormRouteEnum, type FormRoute } from './FormRoutes';

export type ReviewEditableField = 'loanAmount' | 'loanPurpose' | 'employmentStatus' | 'propertyStatus';

// Where the user lands once a review-page edit is complete. Kept as a single
// constant so the exit destination can be changed in the future without
// touching the sequencing logic below.
export const REVIEW_EDIT_EXIT_ROUTE: FormRoute = FormRouteEnum.EMAIL;

const SINGLE_FIELD_ROUTES: Record<ReviewEditableField, FormRoute> = {
  loanAmount: FormRouteEnum.LOAN_AMOUNT,
  loanPurpose: FormRouteEnum.LOAN_PURPOSE,
  employmentStatus: FormRouteEnum.EMPLOYMENT_STATUS,
  propertyStatus: FormRouteEnum.PROPERTY_STATUS,
};

const ALL_FIELDS_SEQUENCE: FormRoute[] = [
  FormRouteEnum.LOAN_AMOUNT,
  FormRouteEnum.LOAN_PURPOSE,
  FormRouteEnum.PROPERTY_STATUS,
  FormRouteEnum.EMPLOYMENT_STATUS,
];

/**
 * Drives the "edit from the partner review page" flow: lets the user
 * revisit one or more prefilled question steps, then routes them back to
 * REVIEW_EDIT_EXIT_ROUTE instead of continuing through the normal
 * (already-skipped) question sequence.
 */
export class ReviewEditController {
  private queue: FormRoute[] = [];

  startField(field: ReviewEditableField): FormRoute {
    this.queue = [SINGLE_FIELD_ROUTES[field]];
    return this.queue[0];
  }

  startAll(): FormRoute {
    this.queue = [...ALL_FIELDS_SEQUENCE];
    return this.queue[0];
  }

  isActive(): boolean {
    return this.queue.length > 0;
  }

  advance(): FormRoute {
    this.queue = this.queue.slice(1);
    return this.queue[0] ?? REVIEW_EDIT_EXIT_ROUTE;
  }

  reset(): void {
    this.queue = [];
  }
}
